import { memo, ReactNode } from 'react';
import {
  Insets,
  StyleProp,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

export const Clickable = memo(
  ({
    hitSlop,
    style,
    children,
    onPress,
  }: {
    hitSlop?: Insets;
    style?: StyleProp<ViewStyle>;
    children?: ReactNode;
    onPress?: () => void;
  }) => {
    if (onPress) {
      return (
        <TouchableOpacity onPress={onPress} style={style} hitSlop={hitSlop}>
          {children}
        </TouchableOpacity>
      );
    }

    return <View style={style}>{children}</View>;
  },
);
